<template>
  <div>
    <h1 class="title">Media Gallery</h1>

    <!-- Photos Section -->
    <section class="media-section">
      <h2 class="subtitle">Photos</h2>
      <div class="media-gallery photos">
        <div
          class="media-item"
          v-for="(image, index) in images"
          :key="index"
        >
          <img
            :src="image"
            alt="Photo"
            @click="openModal(image, 'image', index)"
          />
        </div>
      </div>
    </section>

    <!-- Videos Section -->
    <section class="media-section">
      <h2 class="subtitle">Videos</h2>
      <div class="media-gallery videos">
        <div
          class="media-item"
          v-for="(video, index) in videos"
          :key="index"
        >
          <div class="video-thumbnail" @click="openModal(video, 'video', index)">
            <img
              :src="getThumbnail(video)"
              alt="Video Thumbnail"
            />
            <button class="play-button">
              <i class="fas fa-play"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal for Media Viewing -->
    <div
      class="modal"
      v-if="isModalOpen"
      @click.self="closeModal"
    >
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="mediaType === 'image'">
          <img :src="currentMedia" alt="Media" />
        </div>
        <div v-if="mediaType === 'video'">
          <video :src="currentMedia" controls autoplay></video>
        </div>
        <button v-if="mediaIndex > 0" class="nav-button prev" @click="prevMedia">Previous</button>
        <button v-if="mediaIndex < mediaList.length - 1" class="nav-button next" @click="nextMedia">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPage',
  data() {
    return {
      images: [
        require('@/assets/image1.jpg'),
        require('@/assets/image2.jpg'),
        require('@/assets/image3.jpg'),
      ],
      videos: [
        require('@/assets/video1.mp4'),
      ],
      isModalOpen: false,
      currentMedia: '',
      mediaType: '',
      mediaIndex: 0,
      mediaList: [],
    };
  },
  methods: {
    openModal(media, type, index) {
      this.currentMedia = media;
      this.mediaType = type;
      this.mediaIndex = index;

      if (type === 'image') {
        this.mediaList = this.images;
      } else if (type === 'video') {
        this.mediaList = this.videos;
      }

      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentMedia = '';
      this.mediaType = '';
      this.mediaIndex = 0;
    },
    prevMedia() {
      if (this.mediaIndex > 0) {
        this.mediaIndex--;
        this.currentMedia = this.mediaList[this.mediaIndex];
      }
    },
    nextMedia() {
      if (this.mediaIndex < this.mediaList.length - 1) {
        this.mediaIndex++;
        this.currentMedia = this.mediaList[this.mediaIndex];
      }
    },
    getThumbnail(video) {
      // Generate a thumbnail URL or use a default thumbnail
      return `https://img.youtube.com/vi/${video}/maxresdefault.jpg`;
    }
  },
};
</script>

<style scoped>
.media-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.media-item {
  flex: 1 1 calc(33.333% - 10px);
  overflow: hidden;
  cursor: pointer;
}

.media-item img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.photos .media-item {
  height: 400px; /* Adjust to desired height */
}

.videos .media-item {
  height: 700px; /* Adjust to desired height */
  width: 500px; 
}

.video-thumbnail {
  position: relative;
  height: 100%;
}

.video-thumbnail img {
  height: auto;
  object-fit: cover;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
}

.play-button i {
  font-size: 24px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.modal-content img,
.modal-content video {
  max-width: 100%;
  max-height: 100%;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.nav-button.prev {
  left: 10px;
}

.nav-button.next {
  right: 10px;
}
</style>
